export default __webpack_public_path__ + "static/media/pdf-file.a4553b15.svg";